var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"my-button",class:[
    _vm.type ? 'my-button--' + _vm.type : '',
    _vm.theme ? 'my-button--theme-'+_vm.theme : '',
    {
      'is-disabled': _vm.disabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.round,
      'is-circle': _vm.circle
    }
  ],attrs:{"disabled":(!_vm.clickable && _vm.disabled)|| _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"icon-loading"},[_c('svg',{staticClass:"van-loading__circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])]):_vm._e(),(_vm.icon && !_vm.loading)?_c('svg-icon',{staticClass:"icon",style:({fontSize:_vm.iconSize}),attrs:{"icon-class":_vm.icon}}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }